import { Component, Inject, OnInit, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';

@Component({
    selector: 'app-forbidden',
    imports: [CommonModule, RouterLink],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './forbidden.component.html'
})
export class ForbiddenComponent implements OnInit {
    constructor(
        private readonly titleService: Title,
        public readonly auth: AuthService,
        @Inject(DOCUMENT) public document: Document
    ) {}

    ngOnInit(): void {
        this.titleService.setTitle('403 - Access Restricted | Hive Mind');
    }
}
